import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { closeAutoMode } from "@data/redux/actions/liveMode"

// Auto-close auto-mode overlays when:
//  - the tutor pushes a new activity (newTodoActivity becomes non-null),
//  - the live session ends (isLiveModeEnabled flips to false), or
//  - the tutor switches the student to dialogue mode (soundModeIds includes
//    the student's id) — auto-mode must not stay open while the tutor talks
//    to the student.
// All three are centralized here so the two overlays (AutoEvalOverlay,
// AutoModeChoiceModal) don't each have to listen.
const useAutoModeAutoClose = () => {
    const dispatch = useDispatch()
    const isLive = useSelector((s) => s.liveMode?.isLiveModeEnabled)
    const newTodoActivity = useSelector((s) => s.liveMode?.newTodoActivity)
    const soundModeIds = useSelector((s) => s.liveMode?.soundModeIds)
    const userId = useSelector((s) => s.data?.currentUser?.object?.id)
    const isInDialogue = !!userId && !!soundModeIds?.includes(userId)
    const isAutoModeActive = useSelector(
        (s) =>
            s.liveMode?.autoMode?.showEval ||
            s.liveMode?.autoMode?.showChoiceModal
    )

    useEffect(() => {
        if (!isAutoModeActive) return
        if (!isLive || newTodoActivity || isInDialogue) {
            dispatch(closeAutoMode())
        }
    }, [isAutoModeActive, isLive, newTodoActivity, isInDialogue])
}

export default useAutoModeAutoClose
